<script setup lang="ts">
import { VueFilesPreview } from 'vue-files-preview'
import { ArrowDownTrayIcon, TrashIcon } from '@heroicons/vue/24/outline'
import { computed, onUnmounted, ref } from 'vue'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'
import { storeToRefs } from 'pinia'
import { useAttachmentStore } from '@/stores/useAttachmentStore'
import LoaderCenter from '@/components/common/feedback/LoaderCenter.vue'

const attachmentStore = useAttachmentStore()
const { attachments, loading } = storeToRefs(attachmentStore)
const indexDeleting = ref(-1)

const props = defineProps({
  ressourceId: {
    type: Number,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

function base64ToUint8Array(base64: string): Uint8Array {
  const binaryString = atob(base64)
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes
}

const attachmentsFiles = computed(() => {
  return attachments.value.map((attachment) => {
    return {
      id: attachment.id,
      name: attachment.name,
      file: new File([base64ToUint8Array(attachment.datas)], attachment.name, {
        type: attachment.mimetype,
      }),
      href: URL.createObjectURL(
        new Blob([base64ToUint8Array(attachment.datas)], {
          type: attachment.mimetype,
        }),
      ),
    }
  })
})
onUnmounted(() => (attachments.value = []))
const handleDelete = async (attachment: any, index: number) => {
  indexDeleting.value = index
  await attachmentStore.deleteAttachment(attachment.id)
  attachmentStore.getAllAttachmentByRessourceId(props.ressourceId).then(() => {
    indexDeleting.value = -1
  })
}
</script>

<template>
  <div class="grid grid-cols-3 gap-4 mt-4">
    <div
      v-for="(attachment, index) in attachmentsFiles"
      :key="index"
      class="card col-span-1 border max-h-96"
    >
      <div class="card-body max-h-min p-4">
        <div class="grid grid-cols-12 items-center">
          <h5 class="col-span-9 card-title text-base">{{ attachment.name }}</h5>
          <div class="col-span-3 grid grid-cols-2 gap-2">
            <a :href="attachment.href" :download="attachment.name">
              <div class="tooltip tooltip-top" data-tip="Télécharger">
                <ButtonDaisy text="" :icon="ArrowDownTrayIcon" size="xs" />
              </div>
            </a>
            <div class="tooltip tooltip-top" data-tip="Supprimer">
              <ButtonDaisy
                v-if="indexDeleting != index && !disabled"
                text=""
                :icon="TrashIcon"
                size="xs"
                @click="handleDelete(attachment, index)"
              />
              <loader-center v-else-if="loading"></loader-center>
            </div>
          </div>
        </div>
      </div>
      <figure>
        <VueFilesPreview :file="attachment.file" />
      </figure>
    </div>
  </div>
</template>
